/**
 * Client-side file validation for the two accepted formats. The server re-validates and
 * is the source of truth; this just gives instant, friendly feedback in the browser.
 */
export const ACCEPT = '.pdf,.docx';
export const MAX_MB = 25;
export const MAX_BYTES = MAX_MB * 1024 * 1024;

export type FileProblem = 'type' | 'size' | null;

const ALLOWED_EXT = ['pdf', 'docx'];

export function extensionOf(name: string): string {
  const dot = name.lastIndexOf('.');
  return dot < 0 ? '' : name.slice(dot + 1).toLowerCase();
}

export function validateFile(file: File): FileProblem {
  if (!ALLOWED_EXT.includes(extensionOf(file.name))) return 'type';
  if (file.size > MAX_BYTES) return 'size';
  return null;
}

export function problemMessage(problem: Exclude<FileProblem, null>): string {
  return problem === 'type'
    ? 'That file type isn’t accepted. Please choose a PDF or Word (.docx) file.'
    : `That file is over ${MAX_MB}MB. Please choose a smaller file.`;
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${Math.round(kb)} KB`;
  return `${(kb / 1024).toFixed(1)} MB`;
}
